<template>
  <div>
    <div v-if="type === 'input'" class="input-box">
      <input
        :name="name"
        ref="input"
        @blur="blur"
        :maxlength="maxlength"
        required
        type="text"
        @input="change"
      />
      <span>{{ placeholder }}</span>
      <div v-if="isShowError" class="error-text">
        {{ error || errorText }}
      </div>
    </div>
    <div v-else class="input-box">
      <Select
        :placeholders="placeholder"
        :selectedValue="value"
        size="small"
        :selectData="options"
        @change="selectChange"
      />
      <input type="text" :value="value" :name="name" hidden />
      <div v-if="isShowError" class="error-text">
        {{ error || errorText }}
      </div>
    </div>
  </div>
</template>

<script>
import Select from "@/components/Select/index.desktop";
export default {
  components: { Select },
  name: "W-Input",
  mounted() {
    // 赋予默认值
    if (this.value && this.$refs.input) {
      this.$refs.input.value = this.value;
    }
  },
  props: {
    name: String,
    options: Array,
    type: {
      type: String,
      default: "input",
    },
    errorText: String,
    placeholder: String,
    required: Boolean,
    value: [String, Number],
    rules: {
      type: Array,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      isShowError: false,
      error: "",
    };
  },
  methods: {
    selectChange(_, value) {
      this.$emit("input", value);
    },
    blur() {
      this.setErrorTips();
    },
    checkRules(v) {
      const value = v === undefined ? this.value : v;
      if (this.required && value === "") {
        this.isShowError = true;
        return false;
      }
      if (this.rules && this.rules.length) {
        const idx = this.rules.findIndex((ele) => {
          const { rule, errorText } = ele;
          const type = Object.prototype.toString.call(rule);
          if (type === "[object RegExp]") {
            this.error = errorText;
            // this.isShowError = true;

            return !rule.test(value);
          }
          if (type === "[object Function]") {
            this.error = errorText;
            return !rule(value);
          }
          return false;
        });
        if (idx === -1) return true;
        this.isShowError = true;
        return false;
      }
      return true;
    },
    change({ target: { value } }) {
      this.setErrorTips(value);
      this.$emit("input", value);
    },
    setErrorTips(v) {
      const isPass = this.checkRules(v);
      this.isShowError = !isPass;
    },
  },
};
</script>

<style scoped lang="scss">
.input-box {
  margin-bottom: 32px;
  border: 1px solid transparent;
  background: #34373a;
  outline: none;
  height: 46px;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  position: relative;

  > span {
    position: absolute;
    font-weight: 800;
    font-size: 18px;
    line-height: 46px;
    transition: all 0.4s;
    color: #999999;
    top: 0;
    left: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    width: 90%;
  }

  input[type="text"]:valid + span,
  input[type="text"]:focus + span {
    font-size: 14px;
    line-height: 20px;
    // top: 0;
    // margin-top: 0;
  }
}

.error-text {
  font-size: 12px;
  line-height: 17px;
  color: #d62d2d;
  position: absolute;
  font-weight: normal;
  left: 0;
  bottom: -20px;
}

input[type="text"] {
  z-index: 998;
  position: absolute;
  width: 100%;
  height: 55%;
  font-size: 16px;
  // visibility: hidden;
  text-indent: 18px;
  color: #fff;
  padding: 0;
  left: 0;
  bottom: 0;
  border: none;
}
</style>
